import { useIntl } from "react-intl";
import type { DataTableColumn } from "~components/DataTable/types/dataTableColumn.ts";
import { SiteTableColumns } from "~pages/Sites/SiteListPage/enums/siteTableColumns.ts";
import type { Site } from "~types/site.ts";

export const useGetSiteTableColumns = (): Array<DataTableColumn<Site>> => {
  const { formatMessage } = useIntl();

  return [
    {
      key: SiteTableColumns.NameLocal,
      title: formatMessage({ id: "name.local.full" }),
      dataIndex: "nameLocal",
      sorter: true,
      width: 240,
      ellipsis: { showTitle: true },
    },
    {
      key: SiteTableColumns.SiteId,
      title: formatMessage({ id: "site.id" }),
      dataIndex: "siteId",
      width: 220,
    },
    {
      key: SiteTableColumns.CountryCode,
      title: formatMessage({ id: "country" }),
      dataIndex: "countryCode",
      width: 140,
      render: (value: string | null | undefined) => (value ? formatMessage({ id: `countryCode.${value}` }) : ""),
    },
    {
      key: SiteTableColumns.NameLatin,
      title: formatMessage({ id: "name.latin.full" }),
      dataIndex: "nameLatin",
      sorter: true,
      width: 240,
      ellipsis: { showTitle: true },
    },
    {
      key: SiteTableColumns.AbbreviationLocal,
      title: formatMessage({ id: "name.local.abbreviation" }),
      dataIndex: "abbreviationLocal",
      width: 160,
    },
    {
      key: SiteTableColumns.AbbreviationLatin,
      title: formatMessage({ id: "name.latin.abbreviation" }),
      dataIndex: "abbreviationLatin",
      width: 160,
    },
    {
      key: SiteTableColumns.ExternalId,
      title: formatMessage({ id: "externalId" }),
      dataIndex: "externalId",
      width: 220,
    },
  ];
};
